import {AppointmentRepository} from "@web-libs/features/appointments/domain/appointment.repository";
import {UserRepository} from "@web-libs/features/users/domain/user.repository";
import {AppointmentCategoryRepository} from "@web-libs/features/appointments/domain/category.repository";
import {SpecializationRepository as GeneralSpecializationRepository} from "@web-libs/features/specializations/domain/specialization.repository";
import {ProfileRepository} from "@web-libs/features/profile/domain/profile.repository";
import {VideoRepository} from "@web-libs/features/video/domain/video.repository";
import {CmsRepository} from '@web-libs/features/cms/domain/cms.repository';
import {SpecializationRepository} from "@web-libs/features/appointments/domain/specialization.repository";
import {InstitutionRepository} from "@web-libs/features/institution/domain/institution.repository";
import { InformationRepository } from '@web-libs/features/information/api/information.repository';

export class RepositoryRegistry {

    entries: RepositoryRegistryEntries
    constructor(initialEntries: RepositoryRegistryEntries) {
        this.entries = initialEntries;
    }

    register<T extends keyof RepositoryRegistryEntries>(key: T, repository: RepositoryRegistryEntries[T]) {
        this.entries[key] = repository;
    }

    get<T extends keyof RepositoryRegistryEntries>(key: T): RepositoryRegistryEntries[T] {
        return this.entries[key];
    }
}

export type RepositoryRegistryEntries = {
    InformationRepository: InformationRepository;
    AppointmentRepository: AppointmentRepository;
    UserRepository: UserRepository;
    AppointmentCategoryRepository: AppointmentCategoryRepository;
    SpecializationRepository: SpecializationRepository;
    GeneralSpecializationRepository: GeneralSpecializationRepository;
    ProfileRepository: ProfileRepository;
    VideoRepository: VideoRepository;
    CmsRepository: CmsRepository;
    InstitutionRepository: InstitutionRepository;
}
